import { assignmentErrorMessages } from '@repo/lib/messages/assignmentErrorMessages';
import { useQuery } from '@tanstack/react-query';

import { useErrorMessage } from '#error-message/useErrorMessage';

import { AssignmentService } from './assignmentService';
import { AssignmentKey } from './keys';

export function useGetAssignmentSubmissions(assignmentId?: number, enabled = true) {
  const query = useQuery({
    queryKey: [AssignmentKey.ASSIGNMENT_SUBMISSIONS, assignmentId],
    queryFn: () => AssignmentService.getSubmissions(assignmentId).then((response) => response.data),
    enabled: assignmentId !== undefined && enabled,
  });

  const errorMessage = useErrorMessage(query.error, assignmentErrorMessages);

  return { ...query, errorMessage };
}
